export function formatLocalizedLink(url: string, locale: string): string {
  return url.replace(`{language}`, locale);
}
